// Generated by Melange

import * as Mapre_chat__Chat_attachment from "../../shared/chat/chat_attachment.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Stdlib__Hashtbl from "melange/hashtbl.js";
import * as Stdlib__Option from "melange/option.js";

const files = Stdlib__Hashtbl.create(undefined, 16);

function retain(file) {
  const key = Mapre_web__Browser.nanoid();
  const value = file.type;
  const media_type = value === "" ? "application/octet-stream" : value;
  const preview = Mapre_chat__Chat_attachment.image(media_type) ? URL.createObjectURL(file) : undefined;
  Stdlib__Hashtbl.add(files, key, [
    file,
    preview
  ]);
  return {
    key,
    name: file.name,
    media_type,
    size: file.size,
    preview
  };
}

function find(key) {
  return Stdlib__Option.map((function (prim) {
    return prim[0];
  }), Stdlib__Hashtbl.find_opt(files, key));
}

function release(key) {
  Stdlib__Option.iter((function (param) {
    Stdlib__Option.iter((function (prim) {
      URL.revokeObjectURL(prim);
    }), param[1]);
  }), Stdlib__Hashtbl.find_opt(files, key));
  Stdlib__Hashtbl.remove(files, key);
}

function size(prim) {
  return prim.size;
}

export {
  retain,
  find,
  release,
  size,
}
/* files Not a pure module */
